import React, { createContext, useContext } from 'react';

export interface RichContentFlags {
    /**
     * @description Tells us whether to show RSVPUnit or not.
     */
    shouldShowRSVPUnit?: boolean;
}

export interface DisplayCustomisations {
    /**
     * @description Flags depicting the types of rich content to be shown by the virtualized list item
     */
    richContentFlags?: RichContentFlags;
    /**
     * @description Tells us whether to show upNext or not
     */
    showUpNext?: boolean;
    /**
     * @description Tells us whether to show USQ warning card or not
     */
    showUSQWarningCard?: boolean;
    /**
     * @description Stores the height of the row with OnboardingCards
     */
    onboardingCardHeight?: number;
}

const defaultCustomization: DisplayCustomisations = {
    richContentFlags: { shouldShowRSVPUnit: false },
};
const DisplayCustomisationsContext = createContext<DisplayCustomisations>(defaultCustomization);

export const DisplayCustomisationsProvider: React.FC<DisplayCustomisations> = props => {
    const { children, ...displayCustomisations } = props;

    return (
        <DisplayCustomisationsContext.Provider value={displayCustomisations}>
            {children}
        </DisplayCustomisationsContext.Provider>
    );
};

/**
 * @description Returns the display customizations context.
 * @consumerRole To be used by class components only.
 */
export const getDisplayCustomisationsContext = () => DisplayCustomisationsContext;

/**
 * @description Selector function to get the display customisations from the context depicting the view to be shown to the user.
 * @consumerRole To be used by functional components only.
 */
export const useDisplayCustomisations = () => useContext(DisplayCustomisationsContext);
